import { talenV5 } from "../../variables/app";

export const languagesAvailableInConfig: LanguageAvailableInConfig[] = Object.entries(talenV5).map(
  ([_key, lang_obj]) => lang_obj
);

export type Language = keyof typeof talenV5;

export type LanguageAvailableInConfig = {
  value: Language;
  flag?: string;
  transKey: string;
  label: string;
};
